import Vue from 'vue';
import { mapMutations, mapGetters, mapState } from 'vuex';

import Count from '@components/ui/count.vue';
import Button from '@components/ui/button.vue';
import MovingImage from '@components/ui/movingimage.vue';

import simpleParallax from 'simple-parallax-js';

let PageComponent = {
  name: 'water',
  data() {
    return {
      template: '<p>default temp</p>',
      items: {},
    };
  },
  components: {
    't-count': Count,
    't-button': Button,
    't-image': MovingImage,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
    ...mapMutations('cart', ['addItemToCart']),
    ...mapGetters('cart', ['checkInCart']),
    buttonContent: function(id) {
      return this.checkInCart()(id) ? 'В корзине' : 'В корзину';
    },
  },
  computed: {
    leftMenuVisible: function() {
      return window.innerWidth < 1280;
    },
    ...mapState('params', ['mobile']),
  },
  created() {},
  mounted() {
    setTimeout(() => {
      new simpleParallax(document.querySelectorAll('.item-parallax-js'), {
        scale: 1.1,
      });
    }, 150);

    if (!this.mobile) {
      setTimeout(() => {
        document.querySelectorAll('#water-top-wave').forEach((item) => {
          wavify(item, {
            height: 20,
            bones: 3,
            amplitude: 90,
            color: '#F5F7FA',
            speed: 0.11,
          });
        });
      }, 100);
      setTimeout(() => {
        document.querySelectorAll('#water-bottom-wave').forEach((item) => {
          wavify(item, {
            height: 15,
            bones: 4,
            amplitude: 90,
            color: '#F5F7FA',
            speed: 0.1,
          });
        });
      }, 150);
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let products = document.querySelector('#water');
    if (products) {
      products.remove();
    }

    let url = '/api/templates/products/water';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/products/water/index.js